import { publicClientConfig } from '@/config/public-client-config';

export const TABLE_HEADER_HEIGHT = 80;
export const TABLE_ROW_HEIGHT = 40;
export const MIN_ROWS_ON_PAGE = 1;
export const ROWS_PER_PAGE_PRESETS = [20, 100, 500, 1000];
export const AUTO_ROWS_ON_PAGE_FIT_ENABLED = publicClientConfig.isAutoRowsOnPageFitEnabled;

type CalculateRowsFitOnScreenArgs = {
    scrollContainerHeight: number;
    topControlsHeight: number;
};

export const calculateRowsFitOnScreen = ({
    scrollContainerHeight,
    topControlsHeight,
}: CalculateRowsFitOnScreenArgs): number | null => {
    if (!scrollContainerHeight || !topControlsHeight) {
        return null;
    }

    const availableRowsHeight = scrollContainerHeight - topControlsHeight - TABLE_HEADER_HEIGHT;
    if (!Number.isFinite(availableRowsHeight)) {
        return null;
    }

    return Math.max(MIN_ROWS_ON_PAGE, Math.floor(availableRowsHeight / TABLE_ROW_HEIGHT));
};

type BuildRowsPerPagePresetsArgs = {
    autoRowsOnPageFitEnabled: boolean;
    fittedRowsOnScreen: number | null;
};

export const buildRowsPerPagePresets = ({
    autoRowsOnPageFitEnabled,
    fittedRowsOnScreen,
}: BuildRowsPerPagePresetsArgs): number[] => {
    const values = [autoRowsOnPageFitEnabled ? fittedRowsOnScreen : null, ...ROWS_PER_PAGE_PRESETS].filter(
        (value): value is number => typeof value === 'number' && Number.isInteger(value) && value >= MIN_ROWS_ON_PAGE,
    );

    return Array.from(new Set(values));
};
